import { showErrorSnackbar } from '../../components/snackbar/Snackbar'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { apolloClient } from '../apolloClient'
import { CHANGE_USER_NAME } from './mutations/CHANGE_USER_NAME'
import { ChangeUserNameInput } from '../types/changeUserName'
import { getCurrentUser } from './getCurrentUser'

export const changeUserName = async (input: ChangeUserNameInput) => {
  try {
    await apolloClient
      .mutate({
        mutation: CHANGE_USER_NAME,
        variables: { input: input },
      })
      .then(() => {
        getCurrentUser()
      })
  } catch (err) {
    console.log('Could not change user name. Reason: ', err)
    showErrorSnackbar(formatMessage(messages.profileScreen_changeName_error))
  }
}
